import React from 'react';
import { useFeatureFlag } from 'src/Hooks/useFeatureFlag';
import { FeatureFlag } from 'src/enums/EFeatureFlags';
import { SetupWorkflowAvailability } from './WorkflowAvailability';
import { TWorkflowAvailabilities } from '@/types/TWorkflowAvailabilities';

interface FeatureFlaggedWorkflowAvailabilityProps {
	availability: TWorkflowAvailabilities | undefined;
	setWorkflowAvailability: (
		data: TWorkflowAvailabilities,
		index: number,
		fallbackMessage: string,
		configEnabled: boolean,
	) => Promise<void>;
	index: number;
	isLoading: boolean;
	initialConfigEnabled?: boolean;
	initialFallbackMessage?: string;
}

export const FeatureFlaggedWorkflowAvailability: React.FC<
	FeatureFlaggedWorkflowAvailabilityProps
> = (props) => {
	const isFeatureEnabled = useFeatureFlag(FeatureFlag.WORKFLOW_AVAILABILITY);
	if (!isFeatureEnabled) {
		return null;
	}

	return <SetupWorkflowAvailability {...props} />;
};
